import { PropsWithChildren } from 'react'
import { tv } from 'tailwind-variants'
import { Spinner } from './Spinner'

export interface LoaderProps {
  variant?: 'normal' | 'inline' | 'centered'
  label?: string
  sublabel?: string
}

const loaderProps = tv({
  base: 'flex',
  variants: {
    variant: {
      normal: 'flex-row gap-2',
      inline: 'inline-flex flex-row gap-2',
      centered: 'flex-col items-center',
    },
  },
})

const headerProps = tv({
  variants: {
    variant: {
      normal: '',
      inline: '',
      centered: 'text-xl',
    },
  },
})

const subheaderProps = tv({
  base: 'opacity-75',
  variants: {
    variant: {
      normal: '',
      inline: '',
      centered: 'text-lg',
    },
  },
})

export function Loader(props: PropsWithChildren<LoaderProps>) {
  return (
    <div className={loaderProps({ variant: props.variant ?? 'normal' })}>
      <Spinner className={props.variant === "centered" ? "animate-spin mb-2" : "animate-spin"} />
      {props.label !== '' && <div className={headerProps({ variant: props.variant ?? 'normal' })}>{props.label ?? 'Loading...'}</div>}
      {props.sublabel && <div className={subheaderProps({ variant: props.variant ?? 'normal' })}>{props.sublabel}</div>}
      {props.children}
    </div>
  )
}
